import React from 'react'
import { loadStripe } from "@stripe/stripe-js"

import Button from '../components/Button'
import { LeftRight, Parallax } from '../components/animations'

import saw from '../images/tools/saw.svg'
import chisel1 from '../images/tools/chisel1.svg'
import robot from '../images/robot.png'

function RBOTSection() {
  const stripePromise = loadStripe("pk_test_s8hHRc5PoXepltikDnFlrh8z00xwz2bRTE")

  const redirectToCheckout = async event => {
    event.preventDefault()
    const stripe = await stripePromise
    const { error } = await stripe.redirectToCheckout({
      items: [{ sku: "sku_HEFnGiwtuALO6L", quantity: 1 }],
      successUrl: `https://sharp-bhaskara-629fad.netlify.app/`,
      cancelUrl: `https://sharp-bhaskara-629fad.netlify.app/`,
      shippingAddressCollection: {
        allowedCountries: ['IT'],
      }
    })
    if (error) {
      console.error("Error:", error)
    }
  }
  return <section className="w-full max-w-screen-lg mx-auto relative">
    <div style={{ left: -20, top: 0 }} className="absolute hide-mobile w-56 h-56 -z-10">
      <Parallax>
        <LeftRight>
          <img src={chisel1} alt="chisel" />
        </LeftRight>
      </Parallax>
    </div>
    <div style={{ bottom: -50, right: 0 }} className="absolute hide-mobile w-56 h-56 -z-10">
      <Parallax>
        <LeftRight>
          <img src={saw} alt="saw" />
        </LeftRight>
      </Parallax>
    </div>
    <div className="sm:px-20 md:px-24 px-6 pt-20 pb-32">
      <div className="rounded-lg bg-white shadow-2xl md:flex md:flex-row-reverse h-96 md:h-64">
        <div className="md:w-2/3 p-8 text-center md:text-left items-center flex">
          <div className="w-full md:text-right md:pr-8">
            <h2 className="text-4xl lg:text-5xl font-display text-black">É arrivato RBOT</h2>
            <p className="text-md md:text-lg lg:text-xl text-black">Dolore tempor esse dolor laboris fugiat dolor<br />Dolore tempor esse dolor</p>
            <div className="pt-4 block md:flex md:flex-row justify-center md:justify-end ">
              <div>
                <Button alternate onPress="/rbot" classes="py-2 md:mr-2 mb-4 md:mb-0 border-none" noHoverEffect>
                  Scopri di più
              </Button>
              </div>
              <div>
                <Button onPress={redirectToCheckout} classes="py-2">
                  ORDINA SUBITO &rarr;
              </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-1/3 md:ml-6 justify-center">
          <img className="object-scale-down w-full h-64 md:h-84 overflow-visible" src={robot} alt="rbot_" />
        </div>
      </div>
    </div>
  </section>
}

export default RBOTSection